/* CUSTOM_PAYMENTVERIFY_BY_CLAUDE (ONYX e27ee0c84a87 phase 2, Ryan 2026-10-12)
   Settings -> Admin: Order Verification (Payment Check) - the JS half. Markup in snippets/rep-settings-payment-verify.liquid.
   GET/POST /admin/payment-verify-config {mode, alerts, callOver}. Loaded from the server first; Save stays disabled until it
   loaded, so a Save can never write a value the page did not read. */
(function () {
  'use strict';
  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.className = 'rep-settings__message rep-settings__message--visible rep-settings__message--' + type;
  }
  function hideMsg(el) { if (el) el.className = 'rep-settings__message'; }

  function init() {
    if (!window.RepPortal || !window.RepPortal.API) return;
    var mode = document.getElementById('settings-paymentverify-mode');
    var alerts = document.getElementById('settings-paymentverify-alerts');
    var callOver = document.getElementById('settings-paymentverify-callover');
    var forward = document.getElementById('settings-paymentverify-forward'); // CUSTOM_PVFORWARD_BY_CLAUDE
    var btn = document.getElementById('settings-paymentverify-btn');
    var msg = document.getElementById('settings-paymentverify-msg');
    if (!mode || !btn) return;
    function apply(c) {
      mode.value = c.mode === 'test' || c.mode === 'live' ? c.mode : 'off';
      if (alerts) alerts.checked = c.alerts === true;
      if (callOver) callOver.value = c.callOver != null ? c.callOver : 5000;
      if (forward) forward.checked = c.forwardReplies === true; // CUSTOM_PVFORWARD_BY_CLAUDE - absent reads OFF
    }
    (async function load() {
      try {
        var d = await window.RepPortal.API.get('/admin/payment-verify-config');
        apply(d.config || {});
        btn.disabled = false;
      } catch (e) {
        showMsg(msg, 'Could not load the current setting - reload before saving.', 'error');
      }
    })();
    btn.addEventListener('click', async function () {
      hideMsg(msg);
      var body = { mode: mode.value, alerts: !!(alerts && alerts.checked), callOver: Number(callOver && callOver.value) };
      if (forward) body.forwardReplies = !!forward.checked; // CUSTOM_PVFORWARD_BY_CLAUDE
      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = 'Saving...';
      try {
        var res = await window.RepPortal.API.post('/admin/payment-verify-config', body);
        apply(res.config || {});
        showMsg(msg, res.meaning || 'Saved.', 'success');
      } catch (e) {
        showMsg(msg, 'Could not save: ' + (e && e.message ? e.message : 'unknown error'), 'error');
      } finally { btn.disabled = false; btn.textContent = orig; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
/* END CUSTOM_PAYMENTVERIFY_BY_CLAUDE */
